import React from "react";
import { MessageSquare } from "lucide-react";

export const EmptyState: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full text-center text-muted-foreground py-12">
      <div className="relative mb-4">
        <div className="absolute inset-0 bg-maitai-green/10 blur-2xl rounded-full" />
        <MessageSquare className="h-12 w-12 mx-auto relative text-maitai-green/40" />
      </div>
      <p className="text-base font-medium mb-1">Start a conversation</p>
      <p className="text-sm text-muted-foreground/70">
        Mention an agent with <span className="text-maitai-green font-medium">@</span>
      </p>
    </div>
  );
};
